import React, { useState } from 'react';
import './onboarding-dialog.css';

const OTHER_EPISODES = [
	{ id: 'u9j677YUQmg', title: 'Episode 2: Endpoints, logic validation & logs' },
	{ id: 'S7y1dfMZyzA', title: 'Episode 3: Project publication' },
	{ id: '62hpdoyxmuY', title: 'Episode 4: Databases' },
	{ id: 'q-ky_uKfEYk', title: 'Episode 5: Data types' },
	{ id: 'BEqY6Nn_cC0', title: 'Episode 6: Variables' },
	{ id: 'N5lXIvxR1V0', title: 'Episode 7: Interacting with databases' },
	{ id: 'RRssZ-xuRmc', title: 'Episode 8: Scopes' },
	{ id: '_j56BUY98kI', title: 'Episode 9: Search node (SQL query)' },
	{ id: 'LdpHbcvRytM', title: 'Episode 10: Loops' },
	{ id: 'PW6F3MAvEq4', title: 'Episode 11: Custom triggers, throw errors & project events' },
	{ id: 'kYmrJe8j6mg', title: 'Episode 12: Scheduled executions (CRON jobs)' },
	{ id: 'x6YPfg8lKIw', title: 'Episode 13 (Final): Definitions' },
];

export interface ITutorialVideoEmbedProps {
	bleedOffset?: number;
}

export const TutorialVideoEmbed: React.FC<ITutorialVideoEmbedProps> = ({ bleedOffset = 0 }) => {
	const [expanded, setExpanded] = useState(false);

	return (
		<>
			<div className="onboarding-video-container" style={{ marginTop: '16px' }}>
				<iframe 
					src="https://www.youtube.com/embed/gQU9KBy1WK0" 
					title="Elyx Tutorial Episode 1"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
					allowFullScreen 
				/>
			</div>

			<div style={{
				height: '1px',
				backgroundColor: 'rgba(0, 0, 0, 0.08)',
				width: bleedOffset ? `calc(100% + ${bleedOffset * 2}px)` : '100%',
				marginLeft: bleedOffset ? `-${bleedOffset}px` : '0',
				marginTop: '32px',
				marginBottom: '32px',
			}} />

			<div className="onboarding-episodes-section">
				<button 
					className="onboarding-episodes-toggle" 
					onClick={() => setExpanded(!expanded)}
				>
					<span>Other Episodes in the Series</span>
					<i 
						className="fa-solid fa-chevron-right" 
						style={{ 
							transition: 'transform 0.3s ease',
							transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
							color: 'rgba(0,0,0,0.54)',
							fontSize: '14px'
						}} 
					/>
				</button>
				
				{expanded && (
					<div className="onboarding-episodes-list">
						{OTHER_EPISODES.map((ep) => (
							<a 
								key={ep.id} 
								href={`https://youtu.be/${ep.id}`} 
								target="_blank" 
								rel="noopener noreferrer"
								className="onboarding-episode-item"
							>
								<img 
									src={`https://img.youtube.com/vi/${ep.id}/mqdefault.jpg`} 
									alt={ep.title} 
									className="onboarding-episode-thumbnail"
									loading="lazy"
								/>
								<div className="onboarding-episode-info">
									<p className="onboarding-episode-title">{ep.title}</p>
								</div>
							</a>
						))}
					</div>
				)}
			</div>
		</>
	);
};

export default TutorialVideoEmbed;
